import React, { useEffect } from "react";
import { Layout } from "Components/Layout/Layout";
import Main from "Containers/Dashboard/Main/Main";
import { useNavigate } from "react-router";
import { DASHBOARD } from "Shared/Constants/routes";

export const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const queryString = window.location.search;
    const targetSearch =
      "?calendar_type=year&year=2025&issues_from=2025-03-01&issues_to=2025-03-30";

    if (queryString !== targetSearch) {
      navigate(DASHBOARD + targetSearch, { replace: true });
    }
  }, []);
  return (
    <Layout>
      <Main />
    </Layout>
  );
};
